import { UserIdSchema } from './ids'
import { z } from 'zod'

export const NoteDataSchema = z.object({
  timestamp: z.number(),
  note: z.string(),
})
export type NoteData = z.infer<typeof NoteDataSchema>

export const NoteWithOwnerSchema = z.object({
  ...NoteDataSchema.shape,
  ownerId: UserIdSchema,
})
export type NoteWithOwner = z.infer<typeof NoteWithOwnerSchema>
